<div *ngIf="data[header.field]" class="info-icon cursor-pointer">
    <div (mouseenter)="data.showImage = true" (mouseleave)="data.showImage = false">
      <img style="float: left" [src]="data[header.field]" alt="Image" height="30" width="30" />
      <div class="speech-bubble left" *ngIf="data.showImage">
        <img [src]="data[header.field]" alt="Image" />
      </div>
    </div>
  </div>
  <div *ngIf="!data[header.field]">
    <mat-icon>hide_image</mat-icon>
  </div>
